import { ChangeDetectionStrategy, Component, input, output, ViewEncapsulation } from '@angular/core';
import { TableTemplateColumnConfig } from '@components/ui/table-template/models/table-template-column-config';
import { PageViewModel } from '@components/ui/table-template/models/page-view-model';
import { DataViewModel } from '@components/ui/table-template/models/data-view-model';
import { LoadingAnimationComponent } from '@shared/components/loading-animation/loading-animation.component';
import { ModalWrapperComponent } from '@components/views/modal-wrapper/modal-wrapper.component';
import { TableTemplateComponent } from '@components/ui/table-template/table-template.component';

@Component({
    selector: 'app-entity-transaction-modal',
    templateUrl: './entity-transaction-modal.component.html',
    styleUrls: ['./entity-transaction-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    imports: [LoadingAnimationComponent, ModalWrapperComponent, TableTemplateComponent]
})
export class EntityTransactionModalComponent<T extends DataViewModel> {
    readonly modalTitle = input.required<string>();
    readonly ariaLabelledBy = input.required<string>();
    readonly dataLoading = input.required<boolean>();
    readonly dataAvailable = input.required<boolean>();
    readonly dataEmpty = input.required<boolean>();
    readonly columns = input.required<TableTemplateColumnConfig[]>();
    readonly currentPage = input.required<PageViewModel<T>>();
    readonly sortField = input.required<string>();
    readonly sortOrder = input.required<number>();
    readonly emptyMessage = input<string>('No transactions available');
    readonly tableMinWidthInRem = input<number>(36);

    readonly sortChanged = output<TableTemplateColumnConfig>();
    readonly searchChanged = output<string>();
    readonly pageChanged = output<number>();

    onSort(column: TableTemplateColumnConfig): void {
        this.sortChanged.emit(column);
    }

    onSearch(searchTerm: string): void {
        this.searchChanged.emit(searchTerm);
    }

    onPage(targetPage: number): void {
        this.pageChanged.emit(targetPage);
    }
}
